import React from 'react';
import PacoteManager from '../components/PacoteManagers';

// Página para gerenciar pacotes de usuários
export default function PacoteManagerPage() {
  return (
    <div style={{ padding: 50 }}>
      <PacoteManager />
    </div>
  );
}
